module.exports = __webpack_public_path__ + "img/sara-logo.2ae6784a.png";